import { ErrorAlert } from "common/ui-components";
import { config } from "core/config";
import { PropsWithChildren, useEffect } from "react";

import { AccountInfo } from "@azure/msal-browser";
import { useAccount } from "@azure/msal-react";
import { CenteredLargeSpinner } from "@bps/fluent-ui";
import { login } from "@bps/msal";

const reloginAttemptedKey = `${config.appKey}_tenant_relogin_attempted`;

export const EnsureTenant = ({ children }: PropsWithChildren) => {
  const account = useAccount();
  const claims = account?.idTokenClaims as AccountInfo["idTokenClaims"] & {
    bpt?: string;
  };

  const hasTenant = !!claims?.bpt;

  const alreadyAttempted =
    sessionStorage.getItem(reloginAttemptedKey) === "true";

  useEffect(() => {
    if (hasTenant) {
      sessionStorage.removeItem(reloginAttemptedKey);
    } else if (!alreadyAttempted) {
      sessionStorage.setItem(reloginAttemptedKey, "true");
      login({ prompt: "login" }).then(() => {});
    }
  }, [hasTenant, alreadyAttempted]);

  if (hasTenant) {
    return <>{children}</>;
  }

  if (alreadyAttempted) {
    return (
      <ErrorAlert error="We couldn't determine your Bp Premier tenant. Please contact support." />
    );
  }

  return <CenteredLargeSpinner label="Signing in..." labelPosition="bottom" />;
};
